import React from 'react';

import './Label.css';

export const Label = () => {
  return (
    <span>
      I agree to{' '}
      <a href="/terms_and_conditions" target="_blank" className="term-and-conditions">
        Terms and Conditions
      </a>
    </span>
  );
};
